<template>
<div>
  <v-subheader class='pl-0' v-if='solo' >Please choose a profession</v-subheader>
  <v-autocomplete
    @click:clear='$emit("clear")'
    autocomplete
    v-model='selected'
    label='Select a profession'
    item-text='name'
    item-value="id"
    return-object
    :items='professions'
    :solo='solo'
    clearable
    :loading='request.loading' >
  </v-autocomplete>
</div>
</template>

<script>
export default {
  name: 'ProfessionPicker',
  props: {
    value: { type: Object },
    solo: { type: Boolean, default: false }
  },
  data () {
    return {
      reqId: 'professions-list',
      selected: null
    }
  },
  mounted () {
    this.get()
    if (this.value) {
      this.selected = this.value
    }
  },
  computed: {
    request () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    professions () {
      return this.getObjectPath(this.request, 'result.data', [])
    }
  },
  watch: {
    value () {
      if (this.value) { this.selected = this.value }
    },
    selected () {
      this.$emit('input', this.selected)
    }
  },
  methods: {
    get () {
      this.$appointmentguru
        .resource('practitioner.professions')
        .id(this.reqId)
        .list()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ProfessionPicker.vue?1ee050de